import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { cloneElement, forwardRef } from "react";
import { getDelay, getDuration, getTimingFunction, reflow } from "./helpers";
import { Transition } from "react-transition-group";
import { Fade } from "./Fade";
import { Slide } from "./Slide";
import { FadingSlide } from "./FadingSlide";
import { Scale } from "./Scale";
import { FadingScale } from "./FadingScale";
import { jsx as _jsx } from "react/jsx-runtime";
var Animated = /*#__PURE__*/forwardRef(function Animated(_ref, ref) {
  var _ref$appear = _ref.appear,
      appear = _ref$appear === void 0 ? true : _ref$appear,
      _children = _ref.children,
      _ref$in = _ref["in"],
      inProp = _ref$in === void 0 ? true : _ref$in,
      animatedProperties = _ref.animatedProperties,
      _ref$hideOnExit = _ref.hideOnExit,
      hideOnExit = _ref$hideOnExit === void 0 ? true : _ref$hideOnExit,
      timingFunction = _ref.timingFunction,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? {} : _ref$animation,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 500 : _ref$duration,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$mountOnEnter = _ref.mountOnEnter,
      mountOnEnter = _ref$mountOnEnter === void 0 ? false : _ref$mountOnEnter,
      _ref$unmountOnExit = _ref.unmountOnExit,
      unmountOnExit = _ref$unmountOnExit === void 0 ? false : _ref$unmountOnExit,
      onEnter = _ref.onEnter,
      onEntering = _ref.onEntering,
      onEntered = _ref.onEntered,
      onExit = _ref.onExit,
      onExiting = _ref.onExiting,
      onExited = _ref.onExited,
      addEndListener = _ref.addEndListener,
      style = _ref.style;

  var handleOnEnter = function handleOnEnter(node, isAppearing) {
    // Make sure exited and entering don't happen at the same time when mountOnEnter = true
    reflow(node);
    onEnter == null ? void 0 : onEnter(node, isAppearing);
  };

  return /*#__PURE__*/_jsx(Transition, {
    "in": inProp,
    timeout: duration,
    appear: appear,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    onEnter: handleOnEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    addEndListener: addEndListener,
    children: function children(status) {
      return /*#__PURE__*/cloneElement(_children, _objectSpread(_objectSpread({}, _children.props), {}, {
        ref: ref,
        style: _objectSpread(_objectSpread(_objectSpread({}, _children.props.style), {}, {
          transition: "unset",
          visibility: hideOnExit && status === "exited" && !inProp ? "hidden" : undefined
        }, animation[status]), {}, {
          transitionTimingFunction: getTimingFunction(timingFunction, status),
          transitionDuration: getDuration(duration, status) + "ms",
          transitionDelay: getDelay(delay, status) + "ms",
          transitionProperty: animatedProperties
        }, style)
      }));
    }
  });
});
Animated.Fade = Fade;
Animated.Slide = Slide;
Animated.FadingSlide = FadingSlide;
Animated.Scale = Scale;
Animated.FadingScale = FadingScale;
export default Animated;